module.exports = __webpack_public_path__ + "static/img/imac@2x.54f0a75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/MYBANK/imac@2x.png
// module id = KKz9
// module chunks = 69